import { useMemo } from "react";
import { CDN_BASE_URL } from "../utility/constants";

const useEnergyClassImg = (energyClass, lineId, config) => {
  const energyClassImg = useMemo(() => {
    if (!energyClass || !lineId) return null;
    const oldLines = config.haierStEcommLines.productLine.map((item) => item);
    const isOld = oldLines.includes(`${lineId}`);
    return `${CDN_BASE_URL}/classe-energetica/${isOld ? "el" : "nel"}/${encodeURIComponent(
      energyClass
    )}.svg`;
  }, [energyClass, lineId, config]);

  return energyClassImg;
};

export default useEnergyClassImg;
